import React from 'react';
import ReviewSlider from './ReviewSlider';
import { useReviewSlider } from './hooks/useReviewSlider';
import { reviews } from './data/reviewsData';
import { renderStars } from './utils/starUtils';
import './styles/reviews.css';

const Reviews = () => {
  const {
    currentIndex,
    setCurrentIndex,
    nextSlide,
    prevSlide,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    handleInteractionStart,
    handleInteractionEnd
  } = useReviewSlider(reviews.length);

  return (
    <section id="reviews" className="reviews-section">
      <div className="reviews-container">
        <h2 className="reviews-title">What Our Customers Say</h2>
        <ReviewSlider
          currentIndex={currentIndex}
          reviews={reviews}
          renderStars={renderStars}
          handleTouchStart={handleTouchStart}
          handleTouchMove={handleTouchMove}
          handleTouchEnd={handleTouchEnd}
          handleInteractionStart={handleInteractionStart}
          handleInteractionEnd={handleInteractionEnd}
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          setCurrentIndex={setCurrentIndex}
        />
      </div>
    </section>
  );
};

export default Reviews;
